import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { BookmarkParentType } from '~/apollo/generated/v3/graphql';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { TaggedSOItemListV4 } from '~/components/supporting-object/tagged-so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const OUTCROP_TRAINING_IMAGES_PAGE = graphql(`
  query OutcropTrainingImagesTab($id: ID!) {
    outcropGet(id: $id) {
      id
      trainingImages {
        ...trainingImageParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
      }

      studies {
        ...studyParts
        trainingImages {
          ...trainingImageParts
          pictures {
            ...soPictureParts
          }
          files {
            ...fileParts
          }
        }
      }
    }
  }
`);

export default function OutcropTrainingImagesPage() {
  return (
    <ApolloProviderV4>
      <OutcropTrainingImagesPageInner />
    </ApolloProviderV4>
  );
}

function OutcropTrainingImagesPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(OUTCROP_TRAINING_IMAGES_PAGE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    { query: OUTCROP_TRAINING_IMAGES_PAGE, variables: { id: outcropId } },
  ]);

  const outcrop = data?.outcropGet;

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  const trainingImages = R.sortBy(
    t => t.priority ?? Infinity,
    outcrop?.trainingImages,
  );
  const studies = R.sortBy(s => s.name, outcrop?.studies);

  return (
    <>
      <SOItemListV4
        items={trainingImages}
        soParentType="outcrop"
        soParentId={outcropId}
        bookmarkParentType={BookmarkParentType.TrainingImage}
        refetchQueries={refetchQueries}
      />

      <TaggedSOItemListV4
        outcropId={outcropId}
        studies={studies}
        supportObjectKey="trainingImages"
        refetchQueries={refetchQueries}
      />
    </>
  );
}
